<template>
	<div>
		<!-- 配件列表 -->
		<el-dialog :title="$t('other.a2453')" :visible.sync="showTableCopy" @close="$emit('update:showTable',false)" width="90%">
			<div style="width: 100%;">
				<div>
					<div style="padding-bottom: 10px;">
						<el-input style="width: 30%;" v-model="searchCuscode" :placeholder="$t('other.a2454')" clearable></el-input>
						<el-button type="primary" @click="search()">{{$t('other.a27')}}</el-button>
					</div>
				</div>
				<div>
					<el-table :data="tableList" height="400px" style="width: 100%" @selection-change="handleSelectionChange">
						<el-table-column type="selection" width="55">
						</el-table-column>
						<el-table-column prop="outTradeNo" :label="$t('other.a66')" width="80">
							<template slot-scope="props">
								<el-popover placement="top-start" title="" trigger="hover">
									<img :src="props.row.image" alt="" style="width: 150px;height: 150px">
									<img slot="reference" :src="props.row.image" style="width: 30px;height: 30px">
								</el-popover>
							</template>
						</el-table-column>
						<el-table-column :label="$t('other.a67')" width="180">
							<template slot-scope="props">
								<span>{{props.row.cusCode}}</span>
							</template>
						</el-table-column>
						
						<el-table-column prop="skuName" :label="$t('other.a2139')" >
							<template slot-scope="props">
								<span>{{props.row.skuName ? props.row.skuName : $t('other.a260')}}</span>
							</template>
						</el-table-column>
						<el-table-column prop="variationName" label="skuName">
							<template slot-scope="props">
								<span>{{props.row.variationName ? props.row.variationName : $t('other.a260')}}</span>
							</template>
						</el-table-column>
						<el-table-column prop="platform" :label="$t('other.a2456')">
							<template slot-scope="props">
								<el-input-number size="mini" v-model="props.row.rate"  :min="1"  ></el-input-number>
							</template>
						</el-table-column>
					</el-table>
					<div style="width: 100%;display: flex;justify-content: flex-end;">
						<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage4"
						 :page-sizes="[15, 30, 50, 100]" :page-size="15" layout="total, sizes, prev, pager, next, jumper" :total="tableCount">
						</el-pagination>
					</div>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="confirm()">{{$t('other.a274')}}</el-button>

			</span>
		</el-dialog>
		<!-- 查看绑定情况 -->
		<el-dialog :title="$t('other.a2917')" :visible.sync="bindInfoCopy" @close="$emit('update:bindInfo',false)" width="90%">
			<div style="display: flex;">
				<div style="width: 25%;height: 400px;overflow-y: auto;">
					<el-aside class='personal-aside'>
						<ul style="margin-top: 20px; vor" >
							<li :class=" {'active' :item.active,'bindcss':true}" @click="selectItem(item)" v-for="item in bindInfoList">
								<div>
									<span style="font-size: 22px;margin-right: 20px;">{{item.itemSku}}</span>
									<span>{{$t('other.a838')}}：{{item.shopName}}</span>
								</div>
								<div style="display: flex;align-items: center;margin-top: 10px;">
									<span :class=" {'special' :item.boundNum !== item.amount,'menuitem':true}"  >{{$t('other.a1436')}}：{{item.boundNum}}/{{item.amount}}</span>
									<span class="menuitem">{{$t('other.a2918')}}：{{item.canNum}}</span>
								</div>
								
							</li>
						</ul>
					</el-aside>
				</div>
				<div style="width: 75%;box-sizing: border-box;padding-left: 10px;">
					<div style="display: flex;">
						<div style="width: 80px;height: 80px;"><img style="width: 100%;" :src="chooseBindItem.image"></div>
						<div style="padding-left: 15px;">
							<div style="font-size: 18px;">{{$t('other.a249')}}{{ chooseBindItem.itemSku}}</div>
							<div style="padding: 5px 0;">{{chooseBindItem.itemName}}</div>
							<div>
								<span style="margin-right:15px">{{$t('other.a2919')}}：{{chooseBindItem.isPreOrder ? $t('other.a191') : $t('other.a192')}}</span>
								<span style="margin-right:15px">{{$t('other.a2920')}}：{{chooseBindItem.preDay}}{{$t('other.a177')}}</span>
								<el-button type="primary" v-show="!chooseBindItem.isAutoPre" @click="openPre(0)">{{$t('other.a2921')}}</el-button>
								<el-button type="danger" v-show="chooseBindItem.isAutoPre" @click="openPre(1)">{{$t('other.a2922')}}</el-button>
							
							</div>
						</div>
					</div>
					<el-table :data="chooseBindItem.variations" :key="itemKey" height="300px" style="width: 100%">
					
						<el-table-column label="Sku" width="180">
							<template slot-scope="props">
								<span>{{props.row.variationSku}}</span>
							</template>
						</el-table-column>
						<el-table-column prop="platform" label="name">
							<template slot-scope="props">
								<span>{{props.row.name}}</span>
							</template>
						</el-table-column>
						<el-table-column :label="$t('other.a2923')">
							<template slot-scope="props">
								<span>{{props.row.stock}}</span>
							</template>
						</el-table-column>
						
						<el-table-column prop="platform" :label="$t('other.a2924')" width="350">
							<template slot-scope="props">
								 <el-select size='mini' :disabled="props.row.bound !== '' && props.row.cusCode > 0"    @change="bbtn(props.row,props.$index)"   v-model="props.row.bound" :placeholder="$t('other.a2532')">
								    <el-option
								      v-for="item in chooseBindItem.storeItems"
								      :key="item.skuName"
								      :label="item.skuName"
								      :value="item.skuName">
								    </el-option>
								 </el-select>
								 <span v-show="props.row.cusCode > 0" style="color:red;margin-left:20px;cursor: pointer;" @click="cancleBind(props.row)"> <el-button size="mini" type="danger">{{$t('other.a2925')}}</el-button></span>
								 <span v-show="!props.row.cusCode > 0" style="color:rgb(64, 169, 255);margin-left:20px;cursor: pointer;" @click="BindInfo(props.row)"><el-button size="mini" type="primary">{{$t('other.a2926')}}</el-button></span>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="bindInfoCopy=false">{{$t('other.a274')}}</el-button>

			</span>
		</el-dialog>

		<!-- 添加无产品用户仓库物品信息 -->
			<el-dialog :title="$t('other.a2927')" :visible.sync="addProduct" @close="$emit('update:addStoreItem',false)" width="60%">
			<div >
				<el-form ref="form" :model="form" label-width="80px">
					<el-form-item :label="$t('other.a1119')">
						<el-input v-model="form.name"></el-input>
					</el-form-item>
					<el-form-item :label="$t('other.a817')">
						<el-input v-model="form.name"></el-input>
					</el-form-item>
						<el-form-item :label="$t('other.a2139')" >
						<el-input v-model="form.name"></el-input>
					</el-form-item>
					<el-form-item :label="$t('other.a2928')">
						<el-input v-model="form.name"></el-input>
					</el-form-item>
				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="addProduct=false">{{$t('other.a274')}}</el-button>

			</span>
		</el-dialog>

		<!-- 母sku表 -->
		<el-dialog :title="$t('other.a2929')" :visible.sync="parentSkuDiaCopy" @close="$emit('update:parentSkuDia',false)" width="60%">
			<div style="width: 100%;">
				<div>
					<div style="padding-bottom: 10px;">
						<el-input style="width: 60%;" v-model="searchCuscode" :placeholder="$t('other.a2930')" clearable></el-input>
						<el-button type="primary" @click="search()">{{$t('other.a27')}}</el-button>
					</div>
				</div>
				<div>
					<el-table :data="p_SKUList" height="350px" style="width: 100%" @selection-change="handleSelectionChange">
						<el-table-column type="selection" width="55">
						</el-table-column>
						<el-table-column prop="outTradeNo" :label="$t('other.a66')" width="80">
							<template slot-scope="props">
								<el-popover placement="top-start" title="" trigger="hover">
									<img :src="props.row.storeItems ? props.row.storeItems[0].image : ''" alt="" style="width: 150px;height: 150px">
									<img slot="reference" :src="props.row.storeItems ? props.row.storeItems[0].image : ''" style="width: 30px;height: 30px">
								</el-popover>
							</template>
						</el-table-column>
						<el-table-column :label="$t('other.a659')" >
							<template slot-scope="props">
								<span>{{props.row.itemSku}}</span>
							</template>
						</el-table-column>
						<el-table-column :label="$t('other.a2149')" >
							<template slot-scope="props">
								<span>{{props.row.storeItems.length}}</span>
							</template>
						</el-table-column>
					</el-table>
					<div style="width: 100%;display: flex;justify-content: flex-end;">
						<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage4"
						 :page-sizes="[15, 30, 50, 100]" :page-size="15" layout="total, sizes, prev, pager, next, jumper" :total="P_sku_total">
						</el-pagination>
					</div>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="parentSkuDiaCopy=false">{{$t('other.a106')}}</el-button>
				<el-button type="primary" @click="submit()">{{$t('other.a274')}}</el-button>
			</span>
		</el-dialog>

		<!-- 新增赠品/耗材 -->
		<el-dialog :title="TitleDesc" :visible.sync="openDialogCopy" @close="$emit('update:openDialog',false)" width="60%">
			<div >
				<el-form :model="productInfo"   label-width="100px" class="demo-ruleForm">
					<el-form-item :label="$t('other.a66')" >

						<el-upload
						class="avatar-uploader"
						:headers="token"
						action="https://erp.shopsbu.com/service/access/upload"
						:show-file-list="false"
						:on-success="handleAvatarSuccess"
						>
						<img v-if="imageUrl" :src="imageUrl" class="avatar">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
						</el-upload>
					</el-form-item>
					<el-form-item :label="$t('other.a2139')"  >
						<el-input v-model="productInfo.name" :placeholder="$t('other.a2423')" ></el-input>
					</el-form-item>
					<el-form-item label="skuName" >
						<el-input v-model="productInfo.variationName" :placeholder="$t('other.a2424')" ></el-input>
					</el-form-item>
					<el-form-item :label="$t('other.a2421')"  >
						<el-input v-model="productInfo.weigth" :placeholder="$t('other.a2425')" ></el-input>
					</el-form-item>
					<el-form-item :label="$t('other.a2422')"  >
						<div style="display:flex">
							<el-input style="width:120px;padding:0 5px" v-model="productInfo.long" :placeholder="$t('other.a2426')" ></el-input>
							X <el-input style="width:120px;padding:0 5px" v-model="productInfo.width" :placeholder="$t('other.a2427')" ></el-input>
							X <el-input style="width:120px;padding:0 5px" v-model="productInfo.height" :placeholder="$t('other.a2428')" ></el-input>
						</div>
					</el-form-item>
					
				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="openDialogCopy=false">{{$t('other.a106')}}</el-button>
				<el-button type="primary" @click="submitProduct()">{{$t('other.a274')}}</el-button>
			</span>
		</el-dialog>



	</div>
</template>

<script>
	import userStoreItems from '../../../api/moudles/userStoreItems.js'
	import {
		mapState,
		mapActions,
		mapMutations
	} from 'vuex'
	export default {
		name: "Dialog",
		data() {
			return {
				showTableCopy: false,
				bindInfoCopy: false,
				imageUrl:null,
				bindInfoListCopy:null,
				currentPage4: 1,
				offset: 15,
				multipleSelection: [],
				searchCuscode: null,
				itemVariationId:null,
				chooseBindItem:[],
				itemKey:0,
				ppg:0,
				flagcusCode:0,
				p_SKUList:[],
				isChooseList:[],
				token:{
				token:JSON.parse(localStorage.getItem('userInfo')).token
				},	
				ActieveBound:'',
				openDialogCopy:false,
				productInfo:{
					imageUrl:'',
					name:'',
					long:'',
					width:'',
					height:'',
					weigth:'',
					variationName:''
				},
				getDataParams:{

				},
				parentSkuDiaCopy:false,
				form: {
					name: '',
					region: '',
					date1: '',
					date2: '',
					delivery: false,
					type: [],
					resource: '',
					desc: ''
					},
				addProduct:false,
				P_sku_total:0,
				textDesc:this.$t('other.a2931')
			};
		},

		computed: {
			...mapState({
				userId: state => state.shopaccess.userInfo.userId,
				tableList: state => state.userStoreItems.tableList,
				tableCount: state => state.userStoreItems.tableCount,
				bindInfoList: state => state.userStoreItems.bindInfoList,
				openAutoPre: state => state.userStoreItems.openAutoPre,
				closeAutoPre: state => state.userStoreItems.closeAutoPre,
				bindSuccess: state => state.mygoods.bindSuccess,
				bindError: state => state.mygoods.bindError,
				openDia: state => state.mygoods.openDia,


			}),
			

		},
		props: {
			showTable: {
				type: Boolean,
				default: false
			},
			bindInfo: {
				type: Boolean,
				default: false
			},
			p_sku_Info:{
				type:Object,
				default:()=>{}
			},
			TitleDesc:{
				type:String,
				default(){
					return this.$t("other.a140")
				}
			},
			paramsCopy:{
				type:Object,
				default:()=>{}
			},
			addStoreItem: {
				type: Boolean,
				default: false
			},
			parentSkuDia: {
				type: Boolean,
				default: false
			},
			openDialog: {
				type: Boolean,
				default: false
			},


		},
		watch: {

			parentSkuDia(){
				this.parentSkuDiaCopy=this.parentSkuDia
				if(this.parentSkuDia){
					
					this.getDataParams={
						offset:this.offset,
						page:0,
						userId:this.userId,
						storeId:this.paramsCopy.storeId,
						sellerId:this.userId,
						component:this.paramsCopy.component,
						cusCode:''
					}
					
					this.getPskuData()
					
				}
			},
			openDialog(){
				if(!this.openDialog){
					this.productInfo={}
					this.imageUrl=''
				}
				this.openDialogCopy=this.openDialog
			},

			showTableCopy(){
				if(!this.showTableCopy){
					this.isChooseList=[]
				}
			},

			addStoreItem(){
				this.addProduct=this.addStoreItem
			},
		
			bindInfoList(){
				
				// this.bindInfoList.forEach(p => {
				// 	p.variations.forEach(k => {
				// 		k.bound=''
				// 	})
				// })

				console.log('bindInfoList',this.bindInfoList)
				this.bindInfoList[0].active=true
				this.chooseBindItem=JSON.parse(JSON.stringify(this.bindInfoList[0]))
			},
			bindInfo() {
				this.bindInfoCopy = this.bindInfo
			},
		
			showTable() {
				this.showTableCopy = this.showTable
				console.log(this.showTableCopy)
				if (!this.showTableCopy) {
					this.multipleSelection = []
				}
			},
			searchCuscode() {
				this.$emit('getShopItem', {
					offset: this.offset,
					page: this.ppg,
					cusCode: this.searchCuscode
				})
			},
			bindInfoCopy(){
				if(this.bindInfoCopy == false){
					this.chooseBindItem=[]
					console.log(this.chooseBindItem)
				}
			},
			openAutoPre(){
				if(this.openAutoPre){
					this.chooseBindItem.isAutoPre=true
					console.log('jhdskfnvsd',this.chooseBindItem)
				}
			},
			closeAutoPre(){
				if(this.closeAutoPre){
					this.chooseBindItem.isAutoPre=false
				}
			},
			searchCuscode(){
				if(this.searchCuscode == ''){
					this.getDataParams.cusCode=''
					this.getPskuData()
					this.$emit('getShopItem', {
						offset: this.offset,
						page: 0,
						cusCode: this.searchCuscode
					})
				}else{
					this.ppg=0
				}
			}
		
		
			

		},
		created() {
		

		},
		inject: ['reload'],
		methods: {
			...mapActions('order', [
				'getPrintSheetHistory',
				'getPrintTogether',
				'getGoodsOrder',
				'getSpeciesOrder',
				'getStoreItem',
				'getShopAllItems',
				'viewLogistics',
				'fill_In_logisticsNumber',
				'reloadOrder'


			]),
			
			
			...mapActions('userStoreItems', [
				'jiebanItems',
				'bindItem',
				'isAutoPre'
			
				
				]),

			submitProduct(){
				if(!this.imageUrl){
					this.$message.warning(this.$t('other.a2457'))
					return
				}
				if(!this.productInfo.name){
					this.$message.warning(this.$t('other.a2458'))
					return
				}

				if(!this.productInfo.variationName){
					this.$message.warning(this.$t('other.a2459'))
					return
				}
				this.productInfo.imageUrl=JSON.parse(JSON.stringify(this.imageUrl))
				this.$emit('createItemNotProduct',this.productInfo)
				this.openDialogCopy=false
				this.imageUrl=''
			},

		

			submit(){


				let params={
					cusCodes:this.paramsCopy.cusCode,
					groupId:this.multipleSelection[0].groupId,
					storeId:this.paramsCopy.storeId,
					userId:this.userId,
				}

				userStoreItems
				.updateGroupInfo(params)
				.then(res => {
					if(res.code === 200){
						this.$message.success(this.$t('other.a665'))
						this.parentSkuDiaCopy=false
						this.$emit('reFresh')
						
						
					}
				})

				console.log(params)
			}	,

			handleAvatarSuccess(res, file) {
				this.imageUrl = res.data;
			},

			getPskuData(){
				userStoreItems
				.getStoreItem(this.getDataParams)
				.then(res => {
					if(res.code === 200){
						console.log('11',res.data)
						this.p_SKUList=res.data.groups
						this.P_sku_total=res.data.count
						
					}
				})
			},

				
			
			bbtn(item,index){
				// this.itemKey=Math.random()
				
				
				console.log(this.chooseBindItem)
				this.p_sku_Info.storeItems.forEach(p => {
					if(p.skuName == item.bound){
						this.flagcusCode=p.cusCode
					}
				})
				
			},
			
	
			openPre(num){
				let params
				if(num == 0){
					params={
						hasVariation:true,
						isAutoPre:true,
						itemId:this.chooseBindItem.itemId,
						preDay:this.chooseBindItem.preDay,
						shopee:this.chooseBindItem.platform == 'SHOPEE'
					}
				}else{
					params={
						hasVariation:true,
						isAutoPre:false,
						itemId:this.chooseBindItem.itemId,
						preDay:this.chooseBindItem.preDay,
						shopee:this.chooseBindItem.platform == 'SHOPEE'
					}
				}
				
				
				
				this.$confirm(this.textDesc, this.$t("other.a142"), {
				  confirmButtonText: this.$t('other.a729'),
				  cancelButtonText: this.$t('other.a146'),
				  type: 'warning'
				}).then(() => {
				  
				 
				  this.isAutoPre(params)
				 
				}).catch(() => {
					
				 
				});
			},
			
			
			cancleBind(item){
				let params={
					itemId:this.chooseBindItem.itemId,
					hasVariation:true,
					shopee:this.chooseBindItem.platform == "SHOPEE" ? true : false,
					variation:{
						cusCode:item.cusCode,
						itemId:item.itemId,
						variationId:item.variationId,
					}
					
				}
				
				this.$confirm(this.$t('other.a209'), this.$t("other.a142"), {
				  confirmButtonText: this.$t('other.a145'),
				  cancelButtonText: this.$t('other.a146'),
				  type: 'warning'
				}).then(() => {
				  this.itemVariationId=	item.variationId
				 
				  userStoreItems
				  .jiebanItems(params)
				  .then(res => {
				  	if(res.code === 200) {
				  		this.$message.success(this.$t('other.a210'))
				  		this.chooseBindItem.variations.forEach(p => {
				  			if(p.variationId === this.itemVariationId) {
				  				p.bound=''
								p.cusCode=0
				  			}
				  		})
						console.log(541414)
				  	}else{
				  		this.$message.error(res.msg)
				  	}
				  })
				 
				}).catch(() => {
					
				 
				});
				
				// console.log(params)
				// console.log(item)
				// console.log(this.p_sku_Info)
			},
			
			BindInfo(item){
				this.itemVariationId=item.variationId
				let params={
					cusCode:this.flagcusCode,
					otherItem:[
						{
							itemId:this.chooseBindItem.itemId,
							hasVariation:true,
							shopee:this.chooseBindItem.platform == "SHOPEE" ? true : false,
							variation:{
								itemId:item.itemId,
								rate:item.rate,
								variationId:item.variationId,
							},
							
						}
					],
					userId:this.userId
				}
				userStoreItems
				.bindItem(params)
				.then(res => {
					if(res.code === 200) {
						this.$message.success(this.$t('other.a733'))
						this.chooseBindItem.variations.forEach(p => {
							if(p.variationId === this.itemVariationId) {
								p.cusCode=44444
							}
						})
						console.log(8888)
					}else{
						this.$message.error(res.msg)
					}
				})
	
			},
			search() {
				if(this.parentSkuDia){
					this.getDataParams.cusCode=this.searchCuscode
					this.getPskuData(this.getDataParams)
				}else if(this.searchCuscode){
					this.$emit('getShopItem', {
						offset: this.offset,
						page: this.ppg,
						cusCode: this.searchCuscode
					})
				}
			
			},
			selectItem(item) {
				console.log(this.p_sku_Info)
				this.bindInfoList.forEach(p => {
					p.active=false
				})
				item.active=true
				this.chooseBindItem=JSON.parse(JSON.stringify(item));
				console.log(this.chooseBindItem);
			},
			confirm() {
				console.log(this.isChooseList)
				this.$emit('giveItem', {
					list: this.isChooseList
				})
				this.showTableCopy = false
			},
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
				this.offset = parseInt(`${val}`)
				this.$emit('getShopItem', {
					offset: this.offset,
					page: this.currentPage4
				})
			},
			//显示当前第几页
			handleCurrentChange(val) {
				this.currentPage4 = parseInt(`${val}`)
				this.ppg = (parseInt(`${val}`) - 1) * this.offset
				if(this.parentSkuDia){
					this.getDataParams.page=this.ppg
					this.getPskuData()
				}else{
					this.$emit('getShopItem', {
					offset: this.offset,
					page: this.ppg,
					cusCode: this.searchCuscode,
					component:true
				})
				}
				

			},

			handleSelectionChange(val) {
				this.multipleSelection = val;
				this.multipleSelection.forEach(p => {
					if (p.rate == 0) {
						p.rate = 1
					}
				})
				this.isChooseList=[]
				this.multipleSelection.forEach(p  => {
					this.isChooseList.push(p)
				})
				console.log(this.multipleSelection)
			}










		}
	}
</script>

<style>
	.bindcss {
		cursor: pointer;
		padding: 10px 0;
		border-radius: 5px;
		border-bottom: 1px #EEEEEE solid;
		box-sizing: border-box;
		padding: 5px 5px;
	}
	.active{
		color: rgb(64, 169, 255);
		background-color: #EEEEEE;
	}
	
	.menuitem{
		display: inline-block;
		width: 100px;
		height: 15px;
		line-height: 15px;
		color: #FFFFFF;
		font-size: 12px;
		border-radius: 10px;
		text-align: center;
		padding: 3px 2px;
		
	}
	.menuitem:nth-child(1) {
		background-color: #008161;
		margin-right: 10px;
	}
	.menuitem:nth-child(2) {
		width: 100px;
		background-color: #409EFF;
	}
	
	.special{
		background-color: #E6A23C !important;
		margin-right: 10px;
	}


	.bindcss:hover {
		background: #EEEEEE
	}


 .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
      border-color: #409EFF;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 100px;
      height: 100px;
      line-height: 100px;
      text-align: center;
    }
    .avatar {
      width: 100px;
      height: 100px;
      display: block;
    }


</style>
